<app-centered-layout>
  <app-registration></app-registration>
</app-centered-layout>